// extracted by mini-css-extract-plugin
export default {"content-container":"i2px"};